/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EntityContextDto } from './EntityContextDto';
import {
    EntityContextDtoFromJSON,
    EntityContextDtoFromJSONTyped,
    EntityContextDtoToJSON,
    EntityContextDtoToJSONTyped,
} from './EntityContextDto';

/**
 * Request to add an entity to a case
 * @export
 * @interface CreateCaseEntityRequest
 */
export interface CreateCaseEntityRequest {
    /**
     * Type of the entity
     * @type {string}
     * @memberof CreateCaseEntityRequest
     */
    type: string;
    /**
     * Value of the entity
     * @type {string}
     * @memberof CreateCaseEntityRequest
     */
    value: string;
    /**
     * Confidence level for this entity (0.0 to 1.0)
     * @type {number}
     * @memberof CreateCaseEntityRequest
     */
    confidence?: number;
    /**
     * Context information for the entity
     * @type {EntityContextDto}
     * @memberof CreateCaseEntityRequest
     */
    context?: EntityContextDto;
}

/**
 * Check if a given object implements the CreateCaseEntityRequest interface.
 */
export function instanceOfCreateCaseEntityRequest(value: object): value is CreateCaseEntityRequest {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function CreateCaseEntityRequestFromJSON(json: any): CreateCaseEntityRequest {
    return CreateCaseEntityRequestFromJSONTyped(json, false);
}

export function CreateCaseEntityRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCaseEntityRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'value': json['value'],
        'confidence': json['confidence'] == null ? undefined : json['confidence'],
        'context': json['context'] == null ? undefined : EntityContextDtoFromJSON(json['context']),
    };
}

export function CreateCaseEntityRequestToJSON(json: any): CreateCaseEntityRequest {
    return CreateCaseEntityRequestToJSONTyped(json, false);
}

export function CreateCaseEntityRequestToJSONTyped(value?: CreateCaseEntityRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'value': value['value'],
        'confidence': value['confidence'],
        'context': EntityContextDtoToJSON(value['context']),
    };
}

